import React, { useState } from "react";
import {
  Container,
  Typography,
  useMediaQuery,
  useTheme,
  Grid,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  IconButton,
  Box,
  Link,
} from "@mui/material";
import { member } from "../../lists/240921/memberText";
import { Close, Facebook, Instagram } from "@mui/icons-material";
import { setList } from "../../lists/240921/setListText";

const MemberDetailDialog = ({ open, handleClose }) => {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        メンバー紹介
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {member.map((m, i) => (
          <Grid key={i} mb={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  {m.name} - {m.inst}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" align="justify">
                  <img
                    src={m.img}
                    alt={m.name}
                    style={{
                      float: "right",
                      maxWidth: "200px",
                      width: "30%",
                      height: "auto",
                      margin: "0 0 10px 10px",
                    }}
                  />
                  {m.text}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </DialogContent>
    </Dialog>
  );
};

const LyricDetailDialog = ({ open, handleClose, song }) => {
  if (!song) return null; // songが未定義の場合は何も表示しない

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Grid container alignItems="center" spacing={1}>
          <Grid item>
            <Typography variant="body1" fontWeight="bold" align="left">
              {song.title}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body2" fontWeight="bold" align="left">
              /{song.artist}
            </Typography>
          </Grid>
        </Grid>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid item xs={12}>
          <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
            {song.lyric}
          </Typography>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

//アンケートリンク
export const handleSurvey = () => {
  const surveyLink = "https://forms.gle/Qfs2JnbwKmKro7o76";
  window.open(surveyLink);
};

const Live240921 = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [memberDialogOpen, setMemberDialogOpen] = useState(false);
  const [lyricDialogOpen, setLyricDialogOpen] = useState(false);
  const [selectedSong, setSelectedSong] = useState(null);

  const handleMemberOpen = () => {
    setMemberDialogOpen(true);
  };

  const handleMemberClose = () => {
    setMemberDialogOpen(false);
  };

  const handleLyricOpen = (song) => {
    setSelectedSong(song);
    setLyricDialogOpen(true);
  };

  const handleLyricClose = () => {
    setLyricDialogOpen(false);
  };

  return (
    <Container sx={{ minHeight: "100vh" }}>
      {/* <Header isMobile={isMobile} /> <Toolbar /> */}
      <Grid container spacing={4} sx={{ mb: 4 }}>
        <Grid item xs={12} justifyContent="center">
          <img
            src={`/images/240921/Cover.jpg`}
            alt="吉田雪乃"
            style={{ width: "100%", height: "auto", maxWidth: "800px" }}
          />
        </Grid>
        <Grid item xs={12}>
          <Box mb={4}>
            <Typography
              variant="h6"
              fontWeight="bold"
              align="left"
              gutterBottom
            >
              ごあいさつ
            </Typography>
            <Typography align="justify" variant="body2">
              本日はお越しいただきありがとうございます！
              <br />
              たくさんの方にご縁を繋いでいただき、たくさんの方に応援していただき、無事2ndライブを開催できることになりました。本当にありがとうございます。
              <br />
              まだまだ未熟ではありますが、最後まで楽しんでお過ごしください！！
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box mb={4}>
            {/* Member セクションに下部マージンを追加 */}
            <Typography
              variant="h6"
              fontWeight="bold"
              align="left"
              gutterBottom
            >
              メンバー紹介
            </Typography>
            <Grid
              container
              justifyContent="space-between"
              alignItems="flex-start"
              spacing={2}
            >
              <Grid item xs={5}>
                <img
                  src="/images/240921/All.JPG"
                  alt="All Members"
                  style={{ width: "100%", height: "auto", maxWidth: "200px" }}
                />
              </Grid>
              <Grid item xs={7} container direction="column" spacing={1}>
                {member.map((m, i) => (
                  <Grid item key={i}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary" }}
                      >
                        {m.inst}
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {m.name}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                <Grid item>
                  <Button
                    variant="text"
                    size="small"
                    onClick={handleMemberOpen}
                  >
                    詳しく見る
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" fontWeight="bold" align="left" gutterBottom>
            セットリスト
          </Typography>
          <Grid container direction="column" spacing={2}>
            {setList.map((item, index) => (
              <Grid item key={index}>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item>
                    <Typography variant="body1" fontWeight="bold">
                      {index + 1}.{item.title}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      variant="body2"
                      fontWeight="bold"
                      color="text.secondary"
                    >
                      /{item.artist}
                    </Typography>
                  </Grid>
                </Grid>
                <Typography variant="body2" align="justify">
                  {item.text}
                </Typography>
                <Button
                  variant="text"
                  size="small"
                  onClick={() => handleLyricOpen(item)}
                >
                  歌詞を見る
                </Button>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Box mb={4}>
          <Typography variant="h6" fontWeight="bold" align="left" gutterBottom>
            おわりに
          </Typography>
          <Typography align="justify" variant="body2">
            最後までご覧いただきありがとうございます！ <br />
            これからも歌っていこうと思いますので、またぜひ遊びにきてくれたら嬉しいです。
            <br />
            最後に、下記より感想をお待ちしております。お手隙の時にご回答いただけますと幸いです。よろしくお願いいたします。
          </Typography>
          <Button variant="outlined" size="small" onClick={handleSurvey}>
            回答する
          </Button>
        </Box>
      </Grid>
      <MemberDetailDialog
        open={memberDialogOpen}
        handleClose={handleMemberClose}
      />
      <LyricDetailDialog
        open={lyricDialogOpen}
        handleClose={handleLyricClose}
        song={selectedSong}
      />
      <Box component="footer" sx={{ mt: "auto", py: 2 }}>
        <Grid container justifyContent="center" spacing={1}>
          <Grid item>
            <Link
              href="https://m.facebook.com/yukino.yoshida.315"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook fontSize="large" />
            </Link>
          </Grid>
          <Grid item>
            <Link
              href="https://www.instagram.com/non.__cmr?igsh=MXkxM3UyYWQ2bXVlNA%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram fontSize="large" />
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Live240921;
